import type { FaireProductEntity } from "../../entity_types/product";

export const p_c6xvmdgaz4: FaireProductEntity = {
  token: "p_c6xvmdgaz4",
  type: "product",
  name: "Mike & Ike Original Fruit 0.78 oz 24 packs",
  brandToken: "b_8343je4q5y",
  brandName: "Snacky Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/ab79ccc12904cede1fc31a7b422ba47624a6d9f0216e0309adca02aa6ec7040a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0aaa9b64d462a2b6eb8b2a6708dbdd2cc03fab3fa494196a35fc8c91a25e34f7.jpeg",
    "https://cdn.faire.com/fastly/ca3c64a6a0054a850d8396fac0e79cf0e11fc1af79466b9fd2c7ce7949d9a564.jpeg",
    "https://cdn.faire.com/fastly/ea7044ede0445a0064ee0e1dc6e76d7c7f875f542393884a3a83802e0743a605.jpeg",
    "https://cdn.faire.com/fastly/57b49bfdd38fe4ef5f3ce233a207961c0453e16d05ffb3b142cdd1d1829bd44b.jpeg",
  ],
  priceDollars: 0.39,
  description:
    "**Mike & Ike Original Fruits Chewy Candy — 0.78 oz Theater Boxes (24 Count)**\n\nEnjoy the timeless fruity flavors of Mike & Ike Original Fruits. These chewy candies deliver a burst of classic fruit taste in every bite, with a mix of Cherry, Lemon, Lime, Orange, and Strawberry. Packed in convenient 0.78 oz theater-style boxes, they’re perfect for lunchboxes, parties, concession stands, or on-the-go snacking.\n\n**Product Details:**\n\n* Flavors: Cherry, Lemon, Lime, Orange, Strawberry\n* Format: Chewy fruit-flavored candy\n* Box Size: 0.78 oz each\n* Pack Size: 24 boxes per case\n* Shelf Life: 12 months when stored in a cool, dry place\n* Country of Origin: USA\n\n**Why Customers Love It:**\n\n* Classic fruit flavors loved for generations\n* Fun chewy texture and bright taste\n* Convenient theater boxes great for resale or snacking\n* Gluten-free and fat-free candy option\n* From Mike & Ike, a well-known candy brand\n\n**Case Dimensions & Weight:**\n\n* Case includes 24 mini theater boxes\n* Approx. case weight: 1.2 lbs (0.54 kg)\n\n**Allergen Information:**\nGluten-free and fat-free. Contains corn syrup. Produced in a facility that also processes wheat and soy.\n\nMike & Ike Original Fruits are a candy classic—perfect for satisfying sweet cravings and a must-have for any candy assortment.\n",
  tags: [],
  msrpDollars: 0.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:31.245Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
